import React from 'react'
import BoolField from 'bstrap-react-mobx-admin/field/bool'
import BooleanInput from 'bstrap-react-mobx-admin/input/bool'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import moment from 'moment'

const GoogleplayEdit = ({ store, ...rest }) => {
  const _GPlayInfoForm = ({ state, record, updateFormField, errors }) => {
    const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
    const minDate = store.options.get('timeRestrictions') && store.options.get('timeRestrictions')[0] && store.options.get('timeRestrictions').reverse()[0].date
      ? moment(store.options.get('timeRestrictions').reverse()[0].date).add(1, 'days')
      : moment()
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput label={store.__('Google Play video ID')} attr={'film_platform_id'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} errors={errors} />
          <TextInput label={store.__('Google Play channel')} attr={'channel_id'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} errors={errors} />
          <SelectInput label={store.__('Language')} disabled={stageOneRestricted}
            attr={'language'} record={record} labelattr='text' valueattr='value'
            onChange={updateFormField} optionsrecord={store.options} optionsattr={'Languages'} />
          <TextInput label={store.__('title')} attr={'title'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} errors={errors} />
          <TextInput label={store.__('note')} attr={'note'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} errors={errors} />
          <BooleanInput label={store.__('trailer')} attr={'is_trailer'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} errors={errors} />
          <DateInput label={store.__('published')} attr={'publish_date'} record={record} disabled={stageOneRestricted}
            minDate={minDate} onChange={updateFormField} errors={errors} />
          <DateInput label={store.__('canceled')} attr={'cancel_date'} record={record} disabled={stageTwoRestricted}
            minDate={minDate} onChange={updateFormField} errors={errors} />
        </div>
      </div>
    )
  }

  return (
    <div className='row'>
      <div className='col-xs-12 col-sm-12'>
        <EmbededEntityInput
          store={store}
          attr={'googleplayinfo'}
          edit_title={store.__('edit Google Play video ID record')}
          add_title={store.__('add Google Play video ID record')}
          fields={[
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
            (attr, row) => (
              <OptionsField
                attr={attr}
                val={row[attr]}
                options={store.options.get('Languages')}
                labelattr='text'
                valueattr='value' />
            ),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<DateField attr={attr} val={row[attr]} />),
            (attr, row) => (<DateField attr={attr} val={row[attr]} />)
          ]}
          rowId={(row) => (row.film_platform_id)}
          EditForm={_GPlayInfoForm} {...rest}
        />
      </div>
    </div>
  )
}
export default GoogleplayEdit
